/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Text_Square_BracketsInputs */

const en_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove text between [ and ]`)
};

const fr_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le texte entre [ et ]`)
};

const de_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entferne den Text zwischen [ und ]`)
};

const it_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi il testo tra [ e ]`)
};

const ru_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалите текст между [ и ]`)
};

const es_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar el texto entre [ y ]`)
};

const zh_cn2_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除方括号 [ 和 ] 之间的文本`)
};

const ja_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[と]の間のテキストを削除します`)
};

const hi_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[ और ] के बीच का टेक्स्ट हटा दें`)
};

const pt_pt2_remove_text_square_brackets = /** @type {(inputs: Remove_Text_Square_BracketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover texto entre [ e ]`)
};

/**
* | output |
* | --- |
* | "Remove text between [ and ]" |
*
* @param {Remove_Text_Square_BracketsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_text_square_brackets = /** @type {((inputs?: Remove_Text_Square_BracketsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Text_Square_BracketsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_text_square_brackets(inputs)
	if (locale === "de") return de_remove_text_square_brackets(inputs)
	if (locale === "it") return it_remove_text_square_brackets(inputs)
	if (locale === "ru") return ru_remove_text_square_brackets(inputs)
	if (locale === "es") return es_remove_text_square_brackets(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_text_square_brackets(inputs)
	if (locale === "ja") return ja_remove_text_square_brackets(inputs)
	if (locale === "hi") return hi_remove_text_square_brackets(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_text_square_brackets(inputs)
	return en_remove_text_square_brackets(inputs)
});